import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'

import { Box, Grid } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'

import { JoditEditor, LoadingFeedback } from 'components'
import { ConfirmValidationDialog } from './components'

import helpers from 'helpers'
import * as service from 'service'

import useDocumentGenerate from 'hooks/useDocumentGenerate'
import useSnackbar from 'hooks/useSnackbar'
import useStyles from './styles'

const ReviewStep = () => {
  const {
    documentGenerated,
    documentTemplate,
    hiddenBackButton,
    resetAdvanceStep,
    resetBackButton,
    setDocumentGenerated,
    wantsToAdvanceStep,
    handleNext,
  } = useDocumentGenerate()

  const classes = useStyles()
  const snackbar = useSnackbar()

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [loading, setLoading] = useState(false)

  const { control, errors, handleSubmit } = useForm({
    defaultValues: {
      content: documentGenerated?.content || '',
    },
  })

  const attentionPoint = documentTemplate?.attentionPoint

  const handleConfirmation = async (data) => {
    try {
      setLoading(true)

      const response = await service.dponet.privacyPolicies.put({
        privacyPolicyId: documentGenerated?.id,
        content: data.content,
      })

      const privacyPolicy = response.data?.privacyPolicy ?? documentGenerated

      setDocumentGenerated(privacyPolicy)

      snackbar.open({
        message: 'Documento atualizado com sucesso!',
        variant: 'success',
      })

      handleNext()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (attentionPoint) {
      setOpenConfirmDialog(true)
    }
  }, [attentionPoint])

  useEffect(() => {
    if (wantsToAdvanceStep) {
      handleSubmit(handleConfirmation)()
      resetAdvanceStep()
    }
  }, [wantsToAdvanceStep])

  useEffect(() => {
    hiddenBackButton()

    return () => {
      resetBackButton()
    }
  }, [])

  return (
    <Grid container spacing={2}>
      <LoadingFeedback open={loading} />
      <Grid item xs={12}>
        <Alert variant="standard" severity="info">
          <AlertTitle>Confirme as informações do documento</AlertTitle>
          Agora é hora de revisar o documento que foi gerado a partir do modelo.
          Verifique se todas as informações refletem corretamente a realidade da
          sua empresa — nomes, processos, políticas e detalhes específicos.
          Lembre-se: <strong>você é o responsável</strong> pelas informações,
          então leia com calma e ajuste o que for necessário antes de seguir
          para a próxima etapa.
        </Alert>
        <Box padding={2} className={classes.reviewBox}>
          <Controller
            control={control}
            name="content"
            as={
              <JoditEditor.Editor
                content={documentGenerated?.content}
                error={!!errors?.content}
                helperText={errors?.content?.message}
                configRest={{ height: 460 }}
              />
            }
            mode="onchange"
          />
        </Box>
      </Grid>
      <ConfirmValidationDialog
        open={openConfirmDialog}
        setOpen={setOpenConfirmDialog}
      />
    </Grid>
  )
}

export default ReviewStep
